export class AjaxFormSubmit {
    constructor(optionalOptions = {}) {
        this._forms = document.querySelectorAll('form.ajax-form');
        if (!this._forms) {
            this.destructor();
            return true;
        }

        let action
        let inputs
        let isValid = true

        for (let i = 0; i < this._forms.length; ++i) {
            let form = this._forms[i];
            form.addEventListener("submit", (e) => {
                action = form.getAttribute('action')
                inputs = form.querySelectorAll('.form-require');
                if (!inputs) {
                    return false
                }

                isValid = checkEmptyInputs(inputs)

                if (!isValid) {
                    e.preventDefault();
                }
            })
        }
    }

    destructor() {
        this._forms = null;
    }
}

export default new AjaxFormSubmit();